export const cilListLowPriority = ["24 24","<path d='M12 2.625h11.25v1.5h-11.25v-1.5z'></path><path d='M12 7.625h11.25v1.5h-11.25v-1.5z'></path><path d='M12 12.625h11.25v1.5h-11.25v-1.5z'></path><path d='M15.375 17.625h7.875v1.5h-7.875v-1.5z'></path><path d='M7.837 17.625h-0.28c-2.927 0-5.308-3.028-5.308-6.75s2.381-6.75 5.308-6.75h2.567v-1.5h-2.567c-1.849 0-3.578 0.879-4.867 2.475-1.252 1.549-1.941 3.6-1.941 5.775s0.689 4.225 1.941 5.775c1.289 1.596 3.018 2.475 4.867 2.475h0.28v3.224l6.319-3.927-6.319-4.042zM9.337 17.12l2.007 1.284-2.007 1.247z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-list-low-priority.js
// module id = null
// module chunks = 